<div class="inner-bots-section">
  <div class="section-header">
    <div class="d-flex align-items-center">
      <mat-icon color="accent" class="section-icon">smart_toy</mat-icon>
      <h3 class="section-title">Inner Bots</h3>
    </div>
    <button type="button" mat-raised-button color="accent" (click)="addBots()">
      <mat-icon>add</mat-icon> Add Bot
    </button>
  </div>

  <div class="inner-bot-list" cdkDropList (cdkDropListDropped)="drop($event)">
    @for (bot of botCreator.bots; track bot._id; let j = $index) {
      <ng-container>
        <div class="inner-bot-card" cdkDrag>
          <div class="drag-indicator" cdkDragHandle>
            <mat-icon class="drag-handle">drag_indicator</mat-icon>
          </div>

          <div class="bot-content">
            <div class="bot-info">
              <mat-icon class="bot-icon" color="accent" svgIcon="bot-eye-small"></mat-icon>
              <div class="bot-details">
                <span class="bot-name">{{ bot.name }}</span>
              </div>
            </div>

            <div class="bot-actions">
              <button
                mat-icon-button
                color="accent"
                (click)="openEditBot(bot)"
                matTooltip="Edit bot"
              >
                <mat-icon>edit</mat-icon>
              </button>
              <button
                mat-icon-button
                color="warn"
                (click)="removeBotModal(bot)"
                matTooltip="Delete bot"
              >
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </ng-container>
    }

    @if (!botCreator.bots || botCreator.bots.length === 0) {
      <div class="empty-state">
        <mat-icon class="empty-icon">smart_toy</mat-icon>
        <p class="empty-text">No inner bots yet</p>
        <p class="empty-hint">Click "Add Bot" to create your first inner bot</p>
      </div>
    }
  </div>
</div>
